import React from 'react';
import { bool, shape, string } from 'prop-types';

const Service = ({
  className = '',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M13.5756 9.90948L22.6556 18.9895C23.0556 19.3895 23.0556 20.0195 22.6556 20.3995L20.3556 22.6995C19.9656 23.0895 19.3356 23.0895 18.9456 22.6995L9.83562 13.5895C7.51562 14.4595 4.80562 13.9695 2.94562 12.1095C0.645616 9.81948 0.435616 6.22948 2.29562 3.68948L6.12562 7.51948L7.54562 6.10948L3.70562 2.25948C6.25562 0.399483 9.83562 0.609483 12.1356 2.90948C14.0256 4.80948 14.5056 7.56948 13.5756 9.90948ZM10.1953 11.1289L19.6553 20.5889L20.5353 19.6989L11.0853 10.2489C11.5453 9.65893 11.8453 8.99893 11.9653 8.28893C12.2153 6.89893 11.8053 5.40893 10.7253 4.32893C9.77529 3.38893 8.52529 2.94893 7.28529 3.01893L10.3753 6.10893L6.13529 10.3489L3.04529 7.25893C2.97529 8.49893 3.41529 9.75893 4.36529 10.6989C5.40529 11.7389 6.83529 12.1489 8.19529 11.9489C8.90529 11.8489 9.58529 11.5789 10.1953 11.1289Z" fill="currentColor" />
  </svg>
);

Service.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default Service;
